<template>
    <div>
        <nav-breadcrumb :menu="[{label: ' 分公司指派'}]"/>
        <div class="xzpadd10 bg-purple of">
            <data-table
                :table-data="tableData"
                :columns="columns"
                :page.sync="page"
                :pageSize.sync="pageSize"
                :filters.sync="filters"
                :actions="actions"
            />
        </div>
        <el-dialog v-if="dialogVisible" :visible.sync="dialogVisible" title="指派分公司">
            <el-form :model="dataForm" :rules="dataRules" ref="dataForm" label-width="150px">
                <el-row :gutter="10" class="bg-purple xamhtrpg">
                    <el-col :span="12">
                        <el-form-item label="客户姓名：">
                            {{dataForm.ba__customerName}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="渠道商：">
                            {{dataForm.d__dealerName}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="申贷金额：">
                            {{dataForm.ba__amount|formatMoney}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="分公司：" prop="alloc__branchId" :rules="{required: true, message: '分公司不能为空'}" style="width: 60%">
                            <el-select v-model="dataForm.alloc__branchId">
                                <el-option :label="item.label" :value="item.value" v-for="(item,idx) in branchOptions" :key="idx"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <div class="tr xzmt">
                    <el-button type="primary" @click="onSubmit('dataForm')">确认提交</el-button>
                    <el-button @click="dialogVisible=false">取消</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    import {xmlBuildQuery} from "../../filters/CommonActions";
    import Status2CN from "../../filters/Status2CN";
    import {removeItem} from "../../filters/CommonActions";
    import {formatMoney} from "../../filters/CommonFilters";
    import moment from 'moment'
    export default {
        name: "BranchAllocationList",
        data(){
            return{
                dataForm:{
                    ba__customerName:'',
                    d__dealerName:'',
                    ba__amount:0,
                    alloc__branchId:'',
                    alloc__applicationId:'',
                },
                branchOptions:[],
                dataRules:{},
                dialogVisible:false,
                columns:[
                    {
                        type: 'index'
                    },
                    {
                        label: '客户姓名',
                        field: 'ba__customerName'
                    },
                   /* {
                        label: '手机号',
                        field: 'ba__customerContactNo'
                    },*/
                    {
                        label: '身份证号',
                        field: 'ba__customerIC'
                    },
                    {
                        label: '渠道商',
                        field: 'd__dealerName'
                    },
                    {
                        label: '分公司',
                        field: 'bo__branchName'
                    },
                    {
                        label: '进件时间',
                        field: 't__applicationDate',
                        formatter: function (r,c,v) {
                            return moment(v).format('YYYY-MM-DD HH:mm')
                        }
                    },
                    {
                        label: '状态',
                        field: 'alloc__allocStatus',
                        formatter: function (r,c,v) {
                            if(v)
                                return   Status2CN('branch__alloc__'+v)
                            else
                                return '未指派'
                        }
                    },
                    {
                        label: '操作',
                        opts:[
                            {
                                label: '指派分公司',
                                class: 'el-icon-success',
                                clickHandler: (index, row)=> {
                                    this.dialogVisible = true
                                    this.dataForm.ba__customerName = row.ba__customerName
                                    this.dataForm.d__dealerName = row.d__dealerName
                                    this.dataForm.ba__amount = row.ba__amount
                                    this.dataForm.alloc__applicationId = row.t__applicationId
                                    this.dataForm.alloc__branchId = ''

                                },
                                conditions: row=> {
                                    return row.alloc__allocStatus==null||row.alloc__allocStatus=='Void'

                                }
                            },
                            {
                                label: '撤回',
                                class: 'el-icon-remove',
                                clickHandler: (index, row)=>{
                                    this.removeItem(index, row)
                                },
                                conditions: row=> {
                                    return row.alloc__allocStatus=='Pending'

                                }
                            }
                        ]
                    }
                ],
                tableData: {
                    count: 0,
                    data: []
                },
                page: 1,
                pageSize: 20,
                actions: [
                ],
                filters: {
                    labelWidth: '150px',
                    form: {
                        ba__customerName:'',
                        ba__customerContactNo:'',
                        alloc__allocStatus:'',
                        ba__customerIC:'',
                        d__dealerId:'',
                        bo__branchId:'',
                        t__applicationDate:[],
                    },
                    columns: [

                        {
                            label: '客户姓名',
                            component: 'el-input',
                            field: 'ba__customerName'
                        },

                       /* {
                            label: '手机号',
                            component: 'el-input',
                            field: 'ba__customerContactNo'
                        },*/
                        {
                            label: '状态',
                            component: 'el-select',
                            field: 'alloc__allocStatus',
                            op:'eq',
                            options: [
                                {
                                    label:'未指派',
                                    value:'-',
                                },
                                {
                                    label:'已指派',
                                    value:'Pending',
                                },
                                {
                                    label:'面签中',
                                    value:'Signing',
                                },
                                {
                                    label:'待签约',
                                    value:'Ready',
                                },

                                {
                                    label:'面签完成、待用印',
                                    value:'Completing',
                                },
                                {
                                    label:'已撤回',
                                    value:'Void',
                                }
                            ]
                        },
                        {
                            label: '身份证号码',
                            component: 'el-input',
                            field: 'ba__customerIC'
                        },
                        {
                            label: '渠道商',
                            component: 'el-select',
                            field: 'd__dealerId',
                            options: []
                        },
                        {
                            label: '分公司',
                            component: 'el-select',
                            field: 'bo__branchId',
                            options: []
                        },
                        {
                            label: '进件时间',
                            component: 'date-range-picker',
                            field: 't__applicationDate',
                            op: ['gteq', 'lteq'],
                            span: 12
                        },

                    ],
                    onSubmit:()=>{
                        this.page = 1
                        this.getData()
                    }
                }
            }
        },
        mounted() {
            this.getData()
            this.getDataBranchOfficeSelect()
            this.getDealerList()
        },
        computed: {
            filterParams() {
                return {
                    pageSize: this.pageSize,
                    pageOffset: (this.page - 1) * this.pageSize,
                    'xlist.sort.dataField': 't.applicationDate',
                    'xlist.sort.order': 'desc'
                }
            }
        },
        watch: {
            filterParams: function (newVal) {
                this.getData()
            }
        },
        methods: {
            getData: function () {
                xhr.getDataBranchAllocationList(
                    Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
                    res=> {
                        try {
                            this.tableData = res.data
                        }catch(e){

                        }
                    })

            },

            getDataBranchOfficeSelect: function () {
                xhr.getDataBranchOfficeSelect(
                    Object.assign({}, {}, {}),
                    res=> {
                        try {
                            this.filters.columns[4].options = res.data.data.map(item=>{
                                return {
                                    label: item.bo__branchName,
                                    value:item.bo__branchId,
                                }
                            })
                            this.branchOptions= res.data.data.map(item=>{
                                return {
                                    label: item.bo__branchName,
                                    value:item.bo__branchId,
                                }
                            })
                        }catch(e){

                        }
                    })

            },

            getDealerList: function () {
                xhr.getDealerList(
                    Object.assign({pageSize:0}, {}, {}),
                    res=> {
                        try {
                            this.filters.columns[3].options = res.data.data.map(item=>{
                                return {
                                    label: item.d__dealerName,
                                    value:item.d__dealerId,
                                }
                            })
                        }catch(e){

                        }
                    })

            },
            onSubmit: function (formName) {
                let dataForm = this.dataForm
                this.$refs[formName].validate(valid=> {
                    if (valid) {
                        dataForm.alloc__checked = true
                        xhr.updateAllocateBranch(dataForm, res=> {
                            try {
                                if (res.data.status == 'success') {
                                    this.getData()
                                    this.dialogVisible = false
                                    this.dataForm={
                                        ba__customerName:'',
                                            d__dealerName:'',
                                            ba__amount:0,
                                            alloc__branchId:'',
                                            alloc__applicationId:'',
                                    }
                                }
                            } catch (e) {
                            }
                        })
                    }
                })
            },
            removeItem: function (index, row) {
                this.$confirm('确认撤回指派的分公司吗？').then(()=> {
                        xhr.VoidBranchAllocation( {
                            'alloc.allocationId': row.alloc__allocationId,
                        }, res=> {
                            try {
                                if (res.data.status == 'success') {
                                    if(res.data.status == 'success') {
                                        this.getData()
                                    }
                                }
                            } catch (e) {
                            }
                        })
                    })
                    .catch(()=> {

                    })
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/branchoffice/BranchAllocationList.vue